<!-- 头部 -->
<template>
  <div>
    <div style="height:50px"></div>
    <div :class="{'header-wrap':true,'is-fixed':true}" :style="open?'height: 100%;':''">
      <div :class="{'header-box':true}">
        <img
          :src="open?'./static/img/menu/arrow.png':'./static/img/menu/menu.png'"
          style="margin-left:30px !important;"
          alt
          :class="[open?'close':'open']"
          @click="open=!open"
        />
        <img
          :src="'./static/img/home/EDUCARE.png'"
          class="img"
          @click="handleSelect(1,{key:'home'})"
        />
        <div style="margin-right:30px !important;">
          <span style="background-color: white;color:rgba(102, 102, 102, 0.9);">
            <span style="cursor: pointer;" @click="login" v-if="!userInfo.RealName">注册 | 登录</span>
            <div v-else style="display:flex;justify-content: flex-end;">
              <span style="color:#00477F">{{userInfo.RealName}}</span>
              <span style="cursor: pointer;" @click="loginOut">| 登出</span>
            </div>
          </span>
        </div>
      </div>
      <!-- <transition name="fade"> -->
      <div class="menu" v-if="open" :style="{height:height}">
        <div v-for="(item,index) in menuList" :key="index" :class="{'none-arrow':!item.child}">
          <span
            @click="handleSelect(1,item)"
            class="main"
            :style="item.child? 'border-bottom: 1px solid #ccc;':''"
          >{{item.name}}</span>
          <div v-if="item.child" style="display:flex;flex-direction:column">
            <div
              @click="handleSelect(2,item,i)"
              v-for="(i,j) in item.child"
              :key="j"
              class="child-li"
            >
              <span>{{i.name}}</span>
              <ul v-if="i.child" class="child-child">
                <li
                  v-for="(_i,_j) in i.child"
                  :key="_j"
                  class="child-li"
                  @click="handleSelect(3,item,_i)"
                >{{_i.name}}</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'
import { backTop } from '@/utils/util'
import { getUser } from '@/api/index'
import { setToken, getToken, removeToken } from '@/utils/auth'
import { Message } from 'element-ui'
const FIXHEIGHT = 75
export default {
  name: 'g-header',
  data() {
    return {
      open: false, activeName: 0,
      activeIndex: 'therapy',
      isFixed: false,
      height: '100px',
      userInfo: {
      }
    }
  },
  computed: {
    ...mapGetters(['pageData']),
    dataSource() {
      return this.pageData['mainMenu']
    },
    menuList() {
      const arr = this.pageData['menuList'].filter(v => {
        return v.key != 'home'
      })
      return arr
    }
  },
  methods: {
    getUserInfo() {
      const href = window.location.href
      if (href.includes('access_token')) {
        const token = href.split('access_token=')[1].split('&')[0]
        getUser(token).then(res => {
          const result = JSON.parse(res.data)
          if (result.RealName && result.RealName !== '') {
            setToken(token)
            Cookies.set('userinfo', result)
            this.userInfo = result
            this.$gtag.set({
              'user_id': this.userInfo['RealName'] + '__' + this.userInfo['ID']
            })
          } else if (result.ErrorMessage) {
            Message.warning('系统错误，请稍后再试。')
          }
        })
      } else if (getToken() !== 'undefined' && getToken() !== '' && Cookies.get('userinfo')) {
        const info = JSON.parse(Cookies.get('userinfo'))
        if (info.RealName != '') {
          setToken(getToken())
          Cookies.set('userinfo', info)
          this.userInfo = info
          this.$gtag.set({
            'user_id': this.userInfo['RealName'] + '__' + this.userInfo['ID']
          })
        }
      }
    },
    loginOut() {
      Cookies.remove('redirect_url')
      Cookies.remove('userinfo')
      removeToken()
      window.location.href = window.location.protocol + '//' + window.location.host
    },
    login() {
      var param = window.location.href.substring(window.location.href.indexOf('#') + 1)
      param = param.split('access_token')[0]
      param = param.replace('//', '/')
      Cookies.set('redirect_url', param)
      window.location.href = 'https://passport.bscwin.com/AuthUser/CheckUser?client_id=35&redirect_uri=http%3a%2f%2fio.bostonscientific.cn%2fredirect.html'
    },
    handleSelect(index, item, val) {
      this.activeIndex = item.key
      if (
        ['therapy', 'interventionalVoice', 'centre', 'home', 'patientEducation'].includes(item.key)
      ) {
        const route = {}
        route['name'] = index == 1 ? item.key : val.routeName
        if (val && val.query) {
          route['query'] = val.query
        }
        if (
          (index == 1 && !item.child) ||
          (index == 2 && !val.child) ||
          index == 3
        ) {
          backTop(this)
          this.open = false
          this.$router.push(route)
        }
      } else if (item.key == '8') {
        window.open('http://www.bostonscientific.cn/Institute')
      }
    },
    handleScroll() {
      const scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop
      this.isFixed = scrollTop > FIXHEIGHT
    }
  },
  mounted() {
    this.activeIndex = this.$route.meta.main
    window.addEventListener('scroll', this.handleScroll, true)
    this.getUserInfo()
    this.height = (window.screen.availHeight) + 'px'
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  }
}
</script>
<style lang='less' scoped>
.header-wrap {
  display: flex;
  flex-direction: column;
  width: 100%;
  position: relative;
  z-index: 100;
  background-color: #fff;
  .header-box {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    background: #fff;
    .img {
      width: 187.5px !important;
      height: 50px !important;
      margin: 0 !important;
    }
    .open {
      width: 17px !important;
      height: 12px !important;
      margin: 0 !important;
    }
    .close {
      height: 9.7px !important;
      width: 17.9px !important;
      margin: 0 !important;
    }
  }

  .fade-enter-active {
    transition: all 0.3s ease;
  }
  .fade-leave-active {
    transition: all 0.3s;
  }
  .fade-enter, .fade-leave-to
/* .fade-fade-leave-active for below version 2.1.8 */ {
    transform: translateY(-600px);
    opacity: 0;
  }
  .menu {
    flex: 1;
    background-color: #fff;
    padding: 0 20px;
    position: absolute;
    top: 70px;
    left: 0;
    width: 100%;
    z-index: 100;
    font-size: 18px;
    box-sizing: border-box;
    overflow: auto;
    height: 300px;
    .none-arrow {
      /deep/.el-collapse-item__arrow {
        display: none;
      }
      /deep/.el-collapse-item__content {
        display: none;
      }
    }
    .main {
      font-size: 1.5rem;
      font-weight: bold;
      width: 100%;
      padding: 15px 0;
      display: block;
    }
    .child-li {
      font-size: 1.2rem;
      padding-left: 20px;
      padding: 10px 0 10px 0px;
      display: block;
      > span {
        color: rgb(102, 102, 102);
        padding: 4px 0;
        display: block;
      }
      .child-child {
        font-size: 1rem;
        padding-left: 35px;
        color: rgb(102, 102, 102);
      }
    }
  }
}
.is-fixed {
  position: fixed;
  border-bottom: 1px solid rgb(211, 211, 211);
  left: 0px;
  top: 0;
}
</style>


// WEBPACK FOOTER //
// src/components/gPhoneHeader.vue